export default "__VITE_ASSET__BcoCsAXs__"